import exp from "constants";
import { Rows } from "../../interfaces";
import { PortfolioPerformance } from "src/app/domain/pp/dto/PortfolioPerformance";
import { left, leftBold } from "src/app/util/excelStyles";
import { formats, getCell, safeDivide, spaceInsteadOfNull, withCellStyles } from "../../utils";
import { boldLightGrayBg } from "../financial-statement/capital-account/styles";

export const getPreparedData = (data: PortfolioPerformance[], headersForDisplay: string[], headersForLogic: string[]) => {
  const newData: Rows = [];
  const row = [];
  newData.push(startRow);
  headersForDisplay.forEach((header) => (header === '' ? row.push(null) : row.push(withCellStyles(header, boldLightGrayBg))));
  newData.push(row);
  currentIndex++;
  const activeRows = getActiveRows(data, headersForLogic);
  newData.push(...activeRows);
  return newData;
};

export const getActiveRows = (pps: PortfolioPerformance[], headersForLogic: string[]) => {
  const rows: Rows = [];
  const mappedToHeaders = pps.map((pp) => getNewMapping(pp));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headersForLogic) {
      row.push(withCellStyles(mapped[header], left));
    }
    rows.push(row);
  }
  return rows;
};

export const getNewMapping = (p: PortfolioPerformance) => {
  const rows: Rows = [];
  const row = [];
  const body = {
    Company: p.name,
    'Valuated PPS': getCell({
      v: spaceInsteadOfNull(p.valuatedPps),
      z: formats.toFixed2,
      t: 'n',
    }),
    'space(0)': null,
    'Owned(0)': getCell({
      v: spaceInsteadOfNull(p.fundShares),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Fully diluted(0)': getCell({
      v: spaceInsteadOfNull(p.tas),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Holding(0)': getCell({
      v: spaceInsteadOfNull(p.holdingPercentage),
      z: formats.percents,
      t: 'n',
    }),
    'space(1)': null,
    'Owned(1)': getCell({
      v: spaceInsteadOfNull(p.fundsPreferredShares),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Fully diluted(1)': getCell({
      v: spaceInsteadOfNull(p.totalPreferredShares),
      z: formats.thousandsSeparator,
      t: 'n',
    }),
    'Holding(1)': getCell({
      v: safeDivide(p.fundsPreferredShares, p.totalPreferredShares),
      z: formats.percents,
      t: 'n',
    }),
  };
  return body;
};

export const startRow = ['', '', null,
  '', 'All shares', '', null,
  '', 'Preferred shares', '', null];

export let currentIndex = 0;
